import styled from 'styled-components';
import React from 'react';

interface CrossProps {
    size?: string;
}

const CrossSvg = styled.svg<CrossProps>`
    fill: none;
    stroke: ${props => props.theme.colors.charcoal100};
    stroke-width: 1;
    width: ${props => props.size};
`;

const Cross: React.FunctionComponent<CrossProps> = ({ size = '16px' }) => (
    <CrossSvg size={size} viewBox="0 0 24 24">
        <path d="M1 1 L23 23 M23 1 L1 23" />
    </CrossSvg>
);

export default Cross;
